import IMG_HERO_GB from 'assets/images/email/hero-illustration-top.png';
import IMG_HERO_US from 'assets/images/email/hero-illustration-top-us.png';
import IMG_RESULT_GB from 'assets/images/email/result-illustration.png';
import IMG_RESULT_US from 'assets/images/email/result-illustration-us.png';

export const EMAIL_MARKETING_HERO_IMAGES = {
  US: IMG_HERO_US,
  GB: IMG_HERO_GB,
};

export const EMAIL_MARKETING_RESULT_IMAGES = {
  US: IMG_RESULT_US,
  GB: IMG_RESULT_GB,
};
